let Config = [{
	orgid: "0000", //公司代码=======================邵阳廉桥
	appid: "wxa33f95745cf528f9", //公众号ID
	secret: "8d3ca68e364f4efcddb8bbf4a47a3475", //密钥
	mchId: "1549499511", //商户ID
	key: "862e8f8f2aa66cf8ff3e4362fcc7702c", //签名
}];

export default Config;


// WEBPACK FOOTER //
// ./src/common/Config.js